import artifact from '$houdini/artifacts/MergeVendors'
import { MutationStore } from '../runtime/stores/mutation'

export class MergeVendorsStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
